import React, { Component } from 'react'
import { Col, Row, FormGroup } from "react-bootstrap"
import { reduxForm, propTypes, formValueSelector, getFormSyncErrors, change, Field } from 'redux-form'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'
import { style,blue } from '../../../utils/constants'
import { saveSeasonDivisions, savingSeasonDivisions } from "../../../redux/actions/seasonActions"
import SeasonHeader from './SeasonHeader'
import ErrorList from './ErrorList'
import InfoSaved from './InfoSaved'
import FeesTable from './FeesTable'

const formName = 'seasonfees'
const feesTab = 5

class Fees extends Component {
	static propTypes = {
		...propTypes
	}

	constructor(props,context) {
		super(props,context);

		this.state ={
			updatedFees:[]
		}

		this.handleFeesSave		= this.handleFeesSave.bind(this)
		this.handleFeesUpdate   = this.handleFeesUpdate.bind(this)
		this.handleValueChange	= this.handleValueChange.bind(this)
		this.handleFeesChange	= this.handleFeesChange.bind(this)
	}    

	componentDidUpdate() {
		const {  initialize,datasaved,settingsSaved } = this.props
		if (datasaved) {
			initialize({}, true)
			settingsSaved(true,feesTab)
		}
	}

	handleFeesChange(){
		const { dispatch } = this.props
		dispatch(change(formName,'datasaved',false))
	}

	handleFeesUpdate(changedRecords){
		this.setState({
			updatedFees:changedRecords
		})
	}

	handleFeesSave(){
		const { updatedFees } = this.state
		const { dispatch, fees, settingsseason } = this.props
		const season = fees[settingsseason]

		dispatch(savingSeasonDivisions())
		dispatch(saveSeasonDivisions(settingsseason, updatedFees, season.minRequiredDeposit))
	}

	handleValueChange() {
		const { dispatch, settingsSaved } = this.props
		dispatch(change(formName,'datasaved',false))
		settingsSaved(false,feesTab)
	}

	render() {
		const { savingfee,datasaved,seasonyears, syncErrors, divisions, settingsseason, fees } = this.props
		const errors =  Object.values(syncErrors)
		const season      = `fees[${settingsseason}]`
		
		let seasondivisions = []

		if(divisions && settingsseason){
			seasondivisions = divisions[settingsseason].divisions
		}

		let isSeasonSet = true
		if(fees) {
			isSeasonSet = fees[settingsseason].isSeasonSet
		}
					
		return (
			<Row className="center-block center-text">
				<form className="form-horizontal" sm={10} style={{ padding:'0',margin:'0' }} >
					<Col sm={10}>
					<FormGroup>
						<SeasonHeader seasonyears={seasonyears} />   
					</FormGroup>
					{ (errors.length > 0) && <ErrorList errors={errors}/> }
					<FormGroup style={{ marginLeft:'15px' }}>
					{ 
						<FeesTable onFeesChange= {this.handleFeesChange} onFeesSave= {this.handleFeesUpdate} divisions = {seasondivisions} settingsseason = { settingsseason }/> 
					}
					</FormGroup>
					<FormGroup>
					<label className={style.lblattrs4}>Minimum Required Deposit</label>
					<Field
							type='number'
							name={`${season}.minRequiredDeposit`}
							component='input'
							className="form-control no-spinners"
							style={{ maxWidth: '90px' }}
							max = {99}  
							onChange={this.handleValueChange}                              
					/>
					</FormGroup>
					<FormGroup>
						<Col sm={ 10 }>
							<button type="button"   className="btn btn-default"  style={{ color: blue, fontWeight: 800 }} onClick={this.handleFeesSave} disabled={(datasaved == undefined) || (datasaved == true)  || errors.length > 0 || !isSeasonSet}>
								<i className={savingfee == true? 'fa fa-spinner fa-spin':"fa fa-cogs"} aria-hidden="true" /> &nbsp;&nbsp;Save Settings
							</button>
							{
								datasaved && (<InfoSaved section='Season setup' />)
							}
						</Col>
					</FormGroup>
					</Col>
				</form>                                
			</Row>)
	}
}

function validate(values) {
	const { settingsseason,fees } = values
    const errors = {}
 
    if(settingsseason && fees) {
        const season = fees[settingsseason]
        const { isSeasonSet, minRequiredDeposit } = season
		let errorCounter = 0  
        
        if(isSeasonSet === true)   {

            // check all values are provided
            if (!minRequiredDeposit) {
                errors[errorCounter++] = "Minimum Deposit is required"
            }
        }
        else {
            errors[errorCounter++]  = "Initiate the season by clicking 'Setup season' in the Season Dates tab"            
        }  
    }
    return errors
}  

Fees.propTypes = {
	dispatch:PropTypes.func,
	initialize:PropTypes.func,
	syncErrors:PropTypes.object,
	savingfee:PropTypes.bool,
	datasaved:PropTypes.bool,
	seasonyears:PropTypes.string,
	settingsSaved: PropTypes.func,
	divisions:PropTypes.object,
	settingsseason:PropTypes.number,
	fees:PropTypes.object
}

function mapStateToProps(state,ownProps){   
    const formName =  ownProps.form
	const selector = formValueSelector(formName)
	const selector2 = formValueSelector('seasondivisions')
    const savingfee     = selector(state,'savingfee')
    const datasaved      = selector(state,'datasaved')
    const syncErrors     = getFormSyncErrors(formName)(state) 
    const divisions      = selector2(state,'divisions')
	const settingsseason = selector(state,'settingsseason')  
	const fees = selector(state,'fees')   
    return {     
        savingfee,
        datasaved,
        syncErrors,
        divisions, 
		settingsseason,
		fees
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
			saveSeasonDivisions,
			savingSeasonDivisions,
      },dispatch)
}

export default reduxForm({
  validate,
  form:formName,
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: false,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})(connect(mapStateToProps,mapDispatchToProps)(Fees))




// WEBPACK FOOTER //
// ./src/containers/season/components/Fees.js